export default "__VITE_ASSET__D5YQJdSu__"